
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wallets/[id]/card-activated",
      function () {
        return require("private-next-pages/wallets/[id]/card-activated/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wallets/[id]/card-activated"])
      });
    }
  